import { useEffect, useState } from 'react';

/**
 * Secondes restantes avant de pouvoir confirmer une suppression (évite le clic involontaire).
 * Le décompte repart de `seconds` à chaque ouverture et reste à 0 pendant la fermeture du dialogue.
 */
export function useConfirmCountdown(open, seconds = 3) {
  const [remaining, setRemaining] = useState(seconds);
  const [wasOpen, setWasOpen] = useState(open);

  if (open !== wasOpen) {
    setWasOpen(open);
    if (open) setRemaining(seconds);
  }

  useEffect(() => {
    if (!open || remaining <= 0) return undefined;
    const timer = setTimeout(() => setRemaining(prev => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [open, remaining]);

  return open ? remaining : 0;
}

export default useConfirmCountdown;
